<template>
  <v-container fluid class="pa-2">

    <div class="traka">
      <h2 class="naslov">{{ company.CompanyName || 'Tvrtka' }}</h2>
      <div class="podatak">
        <span class="stanje" :class="company.Activ ? 'da' : 'ne'">
          {{ company.Activ ? 'aktivna' : 'neaktivna' }}
        </span>
        <span v-if="company.CompanyVATID"> &middot; OIB {{ company.CompanyVATID }}</span>
        <span v-if="company.CompanyNameDatabase"> &middot; {{ company.CompanyNameDatabase }}</span>
      </div>
      <div class="radnje">
        <v-btn v-if="smijeUrediti" small color="white" class="plavi-tekst"
          @click="compEdit">Uredi</v-btn>
        <v-btn v-if="smijeUrediti" small color="white" class="plavi-tekst"
          @click="compEditLogo">Logo i memorandum</v-btn>
        <v-btn small text dark @click="complist">Natrag</v-btn>
      </div>
    </div>

    <v-card tile>
      <div v-for="skupina in skupine" :key="skupina.naslov">
        <div class="naslov-kartice">{{ skupina.naslov }}</div>
        <div class="tijelo">
          <div class="dva">
            <div class="par" v-for="(p, i) in skupina.redci" :key="i">
              <span class="o">{{ p.o }}</span>
              <span class="v" :class="{prazno: p.v === '—'}">{{ p.v }}</span>
            </div>
          </div>
          <div v-if="!skupina.redci.length" class="prazna-skupina">nije popunjeno</div>
        </div>
      </div>

      <!-- Rijetko gledano: direktor, kontakt, fiskalizacija i zapis. -->
      <v-expansion-panels accordion flat class="sklopivo">
        <v-expansion-panel v-for="skupina in sklopive" :key="skupina.naslov">
          <v-expansion-panel-header>
            {{ skupina.naslov }}
            <span class="oznaka">{{ skupina.redci.length }}</span>
            <template v-slot:actions><v-icon small>mdi-chevron-down</v-icon></template>
          </v-expansion-panel-header>
          <v-expansion-panel-content>
            <div class="dva">
              <div class="par" v-for="(p, i) in skupina.redci" :key="i">
                <span class="o">{{ p.o }}</span>
                <span class="v">{{ p.v }}</span>
              </div>
            </div>
            <div v-if="!skupina.redci.length" class="prazna-skupina">nije popunjeno</div>
          </v-expansion-panel-content>
        </v-expansion-panel>
      </v-expansion-panels>

      <!-- Brisanje stoji na dnu, odvojeno od radnji koje se koriste svaki dan. -->
      <v-divider></v-divider>
      <v-card-actions>
        <v-btn v-if="$store.state.user.AccessLevel === 1" text small color="red darken-2"
          title="Obriši tvrtku" @click="compDelete">
          <v-icon small>mdi-trash-can</v-icon>
        </v-btn>
        <v-spacer></v-spacer>
        <v-btn small text @click="complist">Natrag</v-btn>
      </v-card-actions>
    </v-card>

    <div class="pink darken-2" v-html="error" />
  </v-container>
</template>

<script>
import CompService from '@/services/CompService'
import dayjs from 'dayjs'

export default {
  name: 'companyview',
  data () {
    return {
      company: {},
      error: ''
    }
  },
  async mounted () {
    if (!this.$store.state.companyid) { return }
    try {
      const dbCompany = await CompService.show(this.$store.state.companyid)
      this.company = dbCompany.data.company || {}
    } catch (error) {
      this.error = String(error)
    }
  },
  computed: {
    smijeUrediti () {
      return this.$store.state.user.AccessLevel <= 3
    },

    skupine () {
      const c = this.company
      return [
        {naslov: 'Osnovno', redci: this.redci([
          ['Naziv tvrtke', c.CompanyName],
          ['Kratki naziv', c.CompanyNameShort],
          ['Naziv baze', c.CompanyNameDatabase],
          ['OIB', c.CompanyVATID],
          ['E-mail', c.Companyemail],
          ['Telefon', c.CompanyPhones],
          ['Adresa', this.spoji(c.CompanyStreet, c.CompanyBuildingNameNumber)],
          ['Mjesto', this.spoji(c.CompanyPostcode, c.CompanyCity)],
          ['Država', c.CompanyState],
          ['Županija', c.CompanyCountyRegion]
        ])},
        {naslov: 'Računi i ispis', redci: this.redci([
          ['Valuta', c.currencyType],
          ['Rok plaćanja (dana)', c.CompanyInvoiceDefDays],
          ['Početni broj računa', c.CompanyStartInvoiceNumber],
          ['Početni broj kase', c.CompanyStartBillNumber],
          ['Vrsta računa', c.CompanyInvoiceType],
          ['Zadano skladište', c.CompanyDefaultWarehouse],
          ['Veličina pisača', c.CompanyPrinterSize],
          ['Nije u sustavu PDV-a', this.daNe(c.notinVAT)],
          ['PDV po naplati', this.daNe(c.CompanyVATonPay)],
          ['Napomena na računu', c.CompanyInvoiceHint]
        ])},
        {naslov: 'eRačun', redci: this.redci([
          ['Posrednik', this.spoji(c.eRacunProviderName, c.eRacunProvider ? '(' + c.eRacunProvider + ')' : '')],
          ['Oznaka programa', c.eRacunSoftwareID],
          ['Korisničko ime', c.eRacunProviderUserName],
          // Kljuc i lozinka se ne pokazuju - na pregledu nemaju sto raditi.
          ['API ključ', c.eRacunProviderAPIkey ? 'upisan' : 'nije upisan'],
          ['Lozinka', c.eRacunProviderUserPassword ? 'upisana' : 'nije upisana'],
          ['Probni način', this.daNe(c.eRacunTestMode)]
        ])},
        {naslov: 'Zadaci i e-mail', redci: this.redci([
          ['E-mail zadužene osobe', c.CompanyTaskEmail],
          ['E-mail računovodstva', c.CompanyAccountingEmail],
          ['Potpis u porukama', c.CompanyMailSignature],
          ['Šalji e-mail sa zadatkom', this.daNe(c.CompanySendEmailTask)],
          ['Učitavanje eSLOG računa', this.daNe(c.CompanyEslogImport)]
        ])}
      ]
    },

    sklopive () {
      const c = this.company
      return [
        {naslov: 'Direktor', redci: this.redci([
          ['Ime i prezime', this.spoji(c.CompanyDirectorFirst, c.CompanyDirectorLast)],
          ['Titula', c.CompanyDirectorTitle],
          ['E-mail', c.CompanyDirectorEmail],
          ['Telefon', c.CompanyDirectorPhone],
          ['Adresa', this.spoji(c.CompanyDirectorAdressStreet, c.CompanyDirectorAdressBuildingNameNumber)],
          ['Mjesto', this.spoji(c.CompanyDirectorPostcode, c.CompanyDirectorCity)],
          ['Datum rođenja', this.datum(c.CompanyDirectorDateOfBirth)],
          ['Zanimanje', c.CompanyDirectorBusinessOccupation]
        ])},
        {naslov: 'Kontakt', redci: this.redci([
          ['Ime i prezime', this.spoji(c.CompanySecretaryFirst, c.CompanySecretaryLast)],
          ['Titula', c.CompanySecretaryTitle],
          ['E-mail', c.CompanySecretaryEmail],
          ['Telefon', c.CompanySecretaryPhone],
          ['Adresa', this.spoji(c.CompanySecretaryAdressStreet, c.CompanySecretaryAdressBuildingNameNumber)],
          ['Mjesto', this.spoji(c.CompanySecretaryPostcode, c.CompanySecretaryCity)]
        ])},
        {naslov: 'Fiskalizacija i maloprodaja', redci: this.redci([
          ['Poslovni prostor', c.CompanyBusinessSpace],
          ['Naplatni uređaj', c.CompanyBusinessDevice],
          ['Prostor (maloprodaja)', c.CompanyBusinessSpaceRetail],
          ['Uređaj (maloprodaja)', c.CompanyBusinessDeviceRetail],
          ['Maloprodajna cijena', this.daNe(c.CompanyUseRetailPrice)],
          ['Provjeri radno vrijeme', this.daNe(c.CompanyRetailWorkCheck)],
          ['Radno vrijeme', this.spoji(c.CompanyRetailWorkFrom, c.CompanyRetailWorkTo, ' - ')]
        ])},
        {naslov: 'Zapis', redci: this.redci([
          ['Vrijedi od', this.datum(c.StartFrom)],
          ['Upisano', this.datumVrijeme(c.createdAt)],
          ['Zadnja izmjena', this.datumVrijeme(c.updatedAt)]
        ])}
      ]
    }
  },
  methods: {
    // Prazna polja se ne pokazuju - od 122 stupca tvrtke njih 51 nikad nije
    // popunjeno, pa bi inace pola ekrana bile crtice.
    redci (parovi) {
      return parovi
        .map(p => ({o: p[0], v: this.tekst(p[1])}))
        .filter(p => p.v !== '')
    },
    tekst (v) {
      if (v === null || v === undefined) { return '' }
      const s = String(v).trim()
      return s === 'null' || s === 'undefined' ? '' : s
    },
    daNe (v) {
      if (v === null || v === undefined || v === '') { return '' }
      return v === true ? 'da' : 'ne'
    },
    spoji (a, b, razdjelnik) {
      return [this.tekst(a), this.tekst(b)].filter(x => x).join(razdjelnik || ' ')
    },
    datum (v) {
      return v ? dayjs(v).format('DD.MM.YYYY') : ''
    },
    datumVrijeme (v) {
      return v ? dayjs(v).format('DD.MM.YYYY HH:mm') : ''
    },

    async complist () {
      try {
        await this.$router.push({name: 'company'})
      } catch (err) {
        this.error = String(err)
      }
    },
    async compDelete () {
      try {
        await this.$router.push({name: 'companydelete'})
      } catch (err) {
        this.error = String(err)
      }
    },
    async compEdit () {
      try {
        this.$store.dispatch('seteditItem', 1)
        await this.$router.push({name: 'companycreate'})
      } catch (err) {
        this.error = String(err)
      }
    },
    async compEditLogo () {
      try {
        this.$store.dispatch('seteditItem', 1)
        await this.$router.push({name: 'companyedit'})
      } catch (err) {
        this.error = String(err)
      }
    }
  }
}
</script>

<style scoped>
.traka {
  background: #0d47a1;
  color: #fff;
  padding: 8px 14px;
  display: flex;
  align-items: center;
  gap: 14px;
  flex-wrap: wrap;
  border-radius: 4px 4px 0 0;
}
.naslov { font-size: 18px; font-weight: 500; margin: 0; }
.podatak { font-size: 12px; opacity: .9; }
.stanje.da { color: #b9f6ca; }
.stanje.ne { color: #ffcdd2; }
.radnje { margin-left: auto; display: flex; gap: 8px; align-items: center; flex-wrap: wrap; }
.plavi-tekst { color: #0d47a1 !important; }

/* Isti naslov skupine kao na obrascu za uredivanje. */
.naslov-kartice {
  font-size: 17px;
  font-weight: 700;
  color: #1565c0;
  background: #eef4fb;
  border-bottom: 2px solid #1565c0;
  padding: 7px 12px;
}
.tijelo { padding: 12px; }

.dva { display: grid; grid-template-columns: 1fr 1fr; gap: 4px 20px; }
.par { display: grid; grid-template-columns: 170px 1fr; gap: 8px; padding: 3px 0; align-items: baseline; }
.par .o { font-size: 12px; color: #5f6b7a; }
.par .v { font-weight: 500; word-break: break-word; }
.prazna-skupina { font-size: 12px; color: #9e9e9e; }

.sklopivo >>> .v-expansion-panel-header {
  min-height: 42px;
  padding: 8px 12px;
  font-weight: 500;
  color: #1565c0;
}
.sklopivo >>> .v-expansion-panel { border-top: 1px solid #e3e8ee; }
.sklopivo >>> .v-expansion-panel-content__wrap { padding: 0 12px 12px; }

.oznaka {
  font-size: 11px;
  font-weight: 400;
  color: #5f6b7a;
  background: #eceff1;
  padding: 1px 7px;
  border-radius: 9px;
  margin-left: 8px;
}

@media (max-width: 900px) {
  .dva { grid-template-columns: 1fr; }
  .radnje { width: 100%; margin-left: 0; }
}
@media (max-width: 600px) {
  .par { grid-template-columns: 130px 1fr; }
}
</style>
